import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OKTA_AUTH } from '@okta/okta-angular';
import { Inject } from '@angular/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(@Inject(OKTA_AUTH) private _oktaAuth: any) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
            
        return next.handle(this.addAuthHeader(request));
    }

    private addAuthHeader(request: HttpRequest<unknown>): HttpRequest<unknown> {

        const authToken = this._oktaAuth.getAccessToken();
        return request.clone({ 
            setHeaders: { 'Authorization': `Bearer ${authToken}` } 
        });
    }
} 